import {
  AppInstallOrigin,
  IntentInstallOptions,
} from '@wix/editor-platform-host-integration-apis';
import { parseAppMarketQueryParam } from '../../../ui/shared/util/tpa/parseAppMarketQueryParam';
import { getEditorInfo, getQueryParams } from '../../../utils';
import {
  EditorType,
  InstallInitiator,
  InstallationOriginType,
} from '@wix/editor-platform-sdk-types';
import { IntentInstallErrorCode, createIntentInstallError } from './errors';

export function getOriginInfoType(isSilent?: boolean) {
  return isSilent
    ? InstallationOriginType.SILENT_INSTALL
    : InstallationOriginType.INTENT_INSTALL;
}

export function getOrigin(options: IntentInstallOptions): AppInstallOrigin {
  if (options.installOrigin) {
    return options.installOrigin;
  }

  const originType = (() => {
    const host = getEditorInfo()?.host;
    switch (host) {
      case 'EDITOR':
        return EditorType.Classic;
      case 'EDITOR_X':
      case 'STUDIO':
        return EditorType.Responsive;
      case undefined:
        throw createIntentInstallError(IntentInstallErrorCode.NoHostDetected);
      default:
        throw createIntentInstallError(
          IntentInstallErrorCode.UnknownHost,
        ).withHost(host);
    }
  })();

  return {
    type: originType,
    initiator: InstallInitiator.Editor,
    info: {
      type: getOriginInfoType(options.isSilent),
    },
  };
}

export function getIntentAppInfo() {
  const queryParams = getQueryParams();
  const appMarketQS = queryParams.appMarketParams;

  if (!appMarketQS) {
    return;
  }

  try {
    const parsedParams = parseAppMarketQueryParam(appMarketQS);

    return { appDefId: parsedParams?.appDefId, version: parsedParams?.version };
  } catch {
    return;
  }
}

export async function findAsyncSequential<T>(
  array: T[],
  predicate: (t: T) => Promise<boolean>,
): Promise<T | undefined> {
  for (const item of array) {
    if (await predicate(item)) {
      return item;
    }
  }
  return undefined;
}
